export default "__VITE_ASSET__dJFvbbpc__"